import { NgModule } from '@angular/core';

import { MapperCONFIG } from 'src/core/sharepoint/model/mapper';
import { SharepointModule } from 'src/core/sharepoint/modules/sharepoint.module';
import { NewsListSharedComponent } from '../components/news-list-shared/news-list-shared.component';
import { NewsMapper } from '../models/news-mapper';


@NgModule({
  declarations: [
  NewsListSharedComponent
],
  imports: [
  SharepointModule
  ],
  providers:[
    { provide: MapperCONFIG, useClass: NewsMapper }
  ],
  exports: [
    NewsListSharedComponent,
    SharepointModule
  ]
})
export class NewsSharedModule {
 
 }
